module.exports = __webpack_public_path__ + "img/sol1.2f6fb34a.png";